import { FC, ReactNode } from 'react';

import classes from './Label.module.scss';

interface LabelProps extends React.HTMLAttributes<HTMLDivElement> {
  children: ReactNode;
}

const Label: FC<LabelProps> = ({ children, ...props }) => {
  return (
    <div className={classes.label} {...props}>
      {children}
    </div>
  );
};

export default Label;
